export const DISCONNECT_TIMEOUT = 5_000;
export const DEBOUNCE_THRESHOLD = 1_000;

export const WIDGET_DEFAULT_CONFIGURATION = {
  AUTHENTICATION_TOKEN: '',
  AUTO_OPEN: false,
  BOT_ICON: '',
  DISPLAY_TIMESTAMP: false,
  ERROR_MESSAGE: 'Something bad happened',
  INPUT_MESSAGE_PLACEHOLDER: 'Type your message here',
  MESSAGE_DELAY: 600,
  MESSAGE_TIMESTAMP: '',
  STREAM_MESSAGES: false,
  WIDGET_TITLE: 'Rasa Widget',
  TOGGLE_FULLSCREEN: false,
  SENDER_ID: '',
  WIDGET_ICON: '',
  INITIAL_PAYLOAD: '',
  SERVER_URL: '',
  REST_ENABLED: false,
};
